/*
 * -------------------------------------------------------------------------
 * 快速判断工具
 * -------------------------------------------------------------------------
 * 连接 electron 中的 helper/is
 */
export default require('../../../../helper/is');



// WEBPACK FOOTER //
// ./src/electron/helper/is.js